export default __webpack_public_path__ + "static/media/sounds/ES_TRO_Reminder_Page_Backup_PU.mp3";